
export const SET =  (state, [variable, value]) =>{
    state[variable] = value
}
export const SETUP =  (state,data) =>{
    state.setup = data;
}

